import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useUser } from "@/hooks/auth/use-user";

export function useDeleteSuggestedTaskMutation(goalId: string) {
  const queryClient = useQueryClient();
  const { user } = useUser();
  
  return useMutation({
    mutationFn: async (taskId: string) => {
      if (!user) throw new Error("Not signed in");
      
      const { error } = await supabase
        .from("planner_suggested_tasks")
        .delete()
        .eq("id", taskId)
        .eq("user_id", user.id);
      
      if (error) throw error;
    },
    onSuccess: () => {
      if (!user) return;
      queryClient.invalidateQueries({ queryKey: ["suggestedTasks", user.id, goalId] });
    },
  });
} 